<div class="mt-2 p-dialog-body grid p-fluid">
    <div class="col-12 row">
        <div class="col-2">User ID</div>
        <div class="col-10">{{data.id}}</div>
    </div>
    <div class="col-12 row mt-2">
        <div class="col-2">Email</div>
        <div class="col-10">{{data.email}}</div>
    </div>
    <div class="col-12 row mt-2">
        <div class="col-2">MT5 Account ID</div>
        <div class="col-10">{{data.mt5Account}}</div>
    </div>

    <div class="col-12 row mt-4">
        <div class="table-responsive">
            <table class="rox-table table-bordered bg-dark">
                <thead>
                    <tr>
                        <th class="font-bold">Open time</th>
                        <th class="font-bold">Close time </th>
                        <th class="font-bold">
                            Bonus Contribution
                        </th>
                        <th class="font-bold">Realized Pnl from bonus</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of  dataTable | paginate
                    : {id: 'deals',
                        itemsPerPage: pageInfo.pageSize,
                        currentPage: pageInfo.pageIndex,
                        totalItems: pageInfo.totalRecord
                      };
                let i = index">
                        <td>{{item.open_time | date: "MM/dd/yyyy HH:mm:ss"}}</td>
                        <td>{{item.close_time | date: "MM/dd/yyyy HH:mm:ss"}}</td>
                        <td>{{item.credit_used |number:"1.2-2"}}</td>
                        <td>{{item.pnl_by_credit |number:"1.2-2"}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row mt-15">
            <div class="col">
                <div class="pagination-wrapper">
                    <pagination-controls id="deals" (pageChange)="onPageChange($event)" autoHide="true"
                        responsive="true" previousLabel="Prev" nextLabel="Next">
                    </pagination-controls>
                </div>
                <div class="ml-5" *ngIf="pageInfo.totalRecord > pageInfo.pageSize">
                    <span>Page</span>
                    <input class="ml-2" type="number" name="pageIndex" [(ngModel)]="pageInfo.pageManual"
                        (keyup)="onKeyupPage($event)" />
                    <button class="btn btn-primary ml-2" style="padding: 2px 0.75rem"
                        (click)="onPageChange(pageInfo.pageManual)">
                        Go
                    </button>
                </div>
            </div>
            <div class="col-auto">
                <span class="data-info ">Found: {{ pageInfo.totalRecord }}
                    {{ pageInfo.totalRecord > 1 ? "records" : "record" }}</span>
            </div>
        </div>
    </div>

</div>